"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendMobileEqual = function TrendMobileEqual() {
  return _react2.default.createElement(
    "g",
    { id: "trend-mobile-equal" },
    _react2.default.createElement("path", {
      d: "M266.8 500H30.5V297.3l236.3.2h202.5V500H266.8zm0-297.3H30.5V0l236.3.2h202.5v202.5H266.8z",
      fillRule: "nonzero"
    })
  );
};

exports.default = TrendMobileEqual;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TrendMobileEqual.js
// module id = 3001
// module chunks = 4